<div id="activities-header" class="activities-specific-css">
  <div class="header">
    <p class="title">{{ 'doktar_app.common.activities' | translate }}</p>
    <p class="subtitle">
      <span>{{ activitiesService.activitiesCount$ | async}}</span>
      <span class="px-1">{{ 'doktar_app.common.activities' | translate }}</span>
    </p>
  </div>

  <div class="d-flex align-items-center gap-3">
    <div class="buttons">
      <p-selectbutton
        [options]="dataViewOptions"
        [(ngModel)]="selectedDataView"
        [allowEmpty]="false"
        optionLabel="justify"
        class="secondary"
        name="dataViewSelect"
        (onChange)="onDataViewChange($event.value)">
        <ng-template #item let-item>
          <i [class]="item.icon"></i>
          <span>{{ item.label | translate }}</span>
        </ng-template>
      </p-selectbutton>
    </div>

    <div class="enterprise-selection-container">
      <div class="enterprise-selection">
        <span class="header-title">{{ 'doktar_app.home.selected_enterprise' | translate }}</span>
        <p-select
          #enterpriseSelect="ngModel"
          [options]="userEnterprises$ | async"
          [(ngModel)]="selectedEnterprise"
          optionLabel="name"
          (onChange)="onSelectEnterpriseChange($event.value)">
          <ng-template #selectedItem let-selectedOption>
            <div class="selected-enterprise">
              <div class="enterprise-name-w-icon">
                <i class="ph-fill ph-handshake"></i>
                <span>{{ selectedOption.name }}</span>
              </div>
            </div>
          </ng-template>
        </p-select>
      </div>
    </div>
  </div>
</div>
